import React from 'react'
import { SkeletonProps, SkeletonValues } from './types'

import './style.scss'

export const Skeleton: React.FC<SkeletonProps.Component> = ({ width, height = SkeletonValues.Default.Height, rounded = SkeletonValues.Default.Rounded, children, ...rest }) => {
  const className = rounded ? `ds-skeleton rounded-${rounded}` : 'ds-skeleton'
  const style = width ? { width: `${width}px`, height: `${height}px` } : { width: '100%', height: `${height}px` }

  return (
    <div {...rest} style={rest.style ? { ...style, ...rest.style } : style} className={rest.className ? `${className} ${rest.className}` : className}>
      <span>{children ?? '\u00A0'}</span>
    </div>
  )
}
